import { render, staticRenderFns } from "./AvailabilityWeek.vue?vue&type=template&id=103454ae&scoped=true"
import script from "./AvailabilityWeek.vue?vue&type=script&lang=js"
export * from "./AvailabilityWeek.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityWeek.vue?vue&type=style&index=0&id=103454ae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103454ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('103454ae')) {
      api.createRecord('103454ae', component.options)
    } else {
      api.reload('103454ae', component.options)
    }
    module.hot.accept("./AvailabilityWeek.vue?vue&type=template&id=103454ae&scoped=true", function () {
      api.rerender('103454ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/AvailabilityWeek.vue"
export default component.exports